module.exports = __webpack_public_path__ + "img/1-1.a64b0227.png";